;
(function( $ ) {
	var methods = {
		isRetina : function () {
			var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
						  (min--moz-device-pixel-ratio: 1.5),\
						  (-o-min-device-pixel-ratio: 3/2),\
						  (min-resolution: 1.5dppx)";

			if (window.devicePixelRatio && window.devicePixelRatio >= 1.5)
				return true;

			if (window.matchMedia && window.matchMedia(mediaQuery).matches)
				return true;

			return false;
		},
		
		resizeImages : function(options) {
		
			var settings = $.extend( {}, $.fn.GenericResize.defaults, options);
			
			// call the generic resize and use 'this' as context (very important!)
			var resizeCount = 0;
			this.each(function () {
				resizeCount += methods.resizeImage.call(this, settings);
			});
			
			if(settings.callBackSelector != "") {
				if (resizeCount > 0) {
					$(settings.callBackSelector).one("load", settings.callBack);
				}
				else {
					settings.callBack.call(this);
				}
			}

			if (settings.genericCallback) {				
				settings.genericCallback.call(this);
			}
		},
		
		resizeImage : function (settings) {
			var isAt2x = methods.isRetina();

			var src = methods.getSource($(this));
			var largestSource = settings.hideWhenNoSource ? "" : src;
						
			for(var i=1; i <= settings.maxBreakpoints && i <= settings.currentBreakpoint; i++)
			{
				var bpSrc  = $(this).attr('data-b'+ i +'-src');
				var bpSrcAt2x = $(this).attr('data-b'+ i +'-src-at2x');			
				if (bpSrc != null && bpSrc != '') {
					 largestSource = bpSrc;
				}
				if (isAt2x && bpSrcAt2x != null && bpSrcAt2x != '') {
					 largestSource = bpSrcAt2x;
				}
			}
			
			if (isAt2x && $(this).attr('data-at2x') != null) {
				largestSource = $(this).attr('data-at2x');
			}

			if (settings.hideWhenNoSource) {
				if (largestSource == '') {
					$(this).css("display", "none");
				} else {
					$(this).css("display", "block");
				}
			}
			
			if(largestSource != src)
			{
				methods.setSource($(this), largestSource);
				return 1;
			}
			return 0;
		},

		getSource: function (element) {
			var source = "";
			var style = element.css('background-image');

			if (element[0].tagName.toLowerCase() == 'img') {
				source = element.attr('src');
			} else if (style != null && style != "none") {
				style = style.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
				source = style;
			} else {
				throw "error no source (src or css background-image) found on this element";
			}

			return source;
		},

		setSource: function (element, largestSource) {
			if (element[0].tagName.toLocaleLowerCase() == 'img') {
				element.attr('src', largestSource);
			} else {
				element.css('background-image', 'url(' + largestSource + ')');
			}
		}
	};

	$.fn.GenericResize = function(options)
	{				
		var method = arguments[0];
 
		if(methods[method]) {
			method = methods[method];
			arguments = Array.prototype.slice.call(arguments, 1);
		} else if( typeof(method) == 'object' || !method ) {
			method = methods.resizeImages;
		} else {
			$.error( 'Method ' +  method + ' does not exist on jQuery.pluginName' );
			return this;
		}
		
		return method.apply(this, arguments);		
	};		

	$.fn.GenericResize.defaults = {		
		callBack: function() {},
		callBackSelector : "",
		maxBreakpoints : 6,
		currentBreakpoint: 1,
		hideWhenNoSource: false
	};
})( jQuery );